/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Url_Error_Dns_FailedInputs */

const en_site_url_error_dns_failed = /** @type {(inputs: Site_Url_Error_Dns_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This address could not be found. Check the spelling.`)
};

const id_site_url_error_dns_failed = /** @type {(inputs: Site_Url_Error_Dns_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat ini tidak ditemukan. Periksa ejaannya.`)
};

/**
* | output |
* | --- |
* | "This address could not be found. Check the spelling." |
*
* @param {Site_Url_Error_Dns_FailedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_url_error_dns_failed = /** @type {((inputs?: Site_Url_Error_Dns_FailedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Url_Error_Dns_FailedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_url_error_dns_failed(inputs)
	return en_site_url_error_dns_failed(inputs)
});